export const PAGE_PATHS = {
  signin: '/signin',
  signup: '/signup',
  successPage: '/signup/success',
  confirmAccount: '/confirm-account',
  newsletters: '/newsletters',
  membershipPlans: '/membership-plans',
  aboutUs: '/about-us',
  projectSubmission: '/project-submission',
  contributionEnquiry: '/contribution-enquiry',
  generalEnquiry: '/general-enquiry',
  termsAndConditions: '/terms-and-conditions',
  commentingPolicy: '/commenting-policy',
  privacyPolicy: '/privacy-policy',
  republishingGuidelines: '/republishing-guidelines',
  editorialCharter: '/editorial-charter',
  complaintsHandlingPolicy: '/complaints-handling-policy',
  faq: '/faq',
  tudPlusFaq: 'https://help.theurbandeveloper.com',
  tudEnquiries: '/tud-enquiries',
  search: '/search',
  logout: '/logout',
  onDemand: '/on-demand',
  // professionalMembersPages: {
  //   upcomingWebinars: "/articles/professional-members-upcoming-webinars",
  //   tudPlusMembershipOnDemand: "/articles/tud-plus-membership-on-demand",
  // },
  tudPlusEnquiry: '/tud-plus-enquiry',
  tudPlusExclusive: '/tud-plus-exclusive',
  latest: '/latest',
  articles: '/articles',
  events: '/events',
  locations: '/locations',
  sectors: '/sectors',
  categories: '/categories',
  pillars: '/pillars',
  authVerify: '/auth/verify'
};

export const USER_ACCOUNT_PATHS = {
  account: '/my-account',
  manageAccount: 'manage-account',
  emailPreferences: 'email-preferences',
  manageSubscription: 'manage-subscription',
  subscription: 'subscription',
  membershipPlans: '/membership-plans',
  linkedAccounts: 'linked-accounts',
  watchlist: 'watchlist',
  upcomingEvents: 'event-registrations',
  organisation: 'corporate-account'
};

/**
 * If a user navigates to the signup page from any of these path prefixes, then they should be
 * redirected back to their referring URL once they've completed the account creation process
 *
 * This list should include any areas of the website where we're serving users with a membership CTA or paywall
 */
export const USER_ACCOUNT_REDIRECT_PATHS = [
  PAGE_PATHS.tudPlusExclusive,
  PAGE_PATHS.latest,
  PAGE_PATHS.articles,
  PAGE_PATHS.events,
  PAGE_PATHS.onDemand,
  PAGE_PATHS.locations,
  PAGE_PATHS.sectors,
  PAGE_PATHS.categories,
  PAGE_PATHS.pillars
];

export const OPERATORS = {
  OR: 'OR',
  AND: 'AND',
  NOT: 'NOT'
};

export const SCROLL_DIRECTION = {
  UP: 'up',
  DOWN: 'down'
};

export default {
  PAGE_PATHS,
  OPERATORS
};

export const EVENTS_AND_WEBINARS_LINKS = {
  EVENTS: '/events',
  ON_DEMAND: '/on-demand',
  TUD_AWARDS: 'https://events.theurbandeveloper.com/tud-awards',
  ULA_AWARDS: 'https://events.theurbandeveloper.com/ula'
};

export const LINKS = {
  contactSupport: 'https://help.theurbandeveloper.com/hc/requests/new',
  serviceDesk: 'https://help.theurbandeveloper.com',
  advertise: '/partnerlab'
};

export const SOCIAL_LINKS = [
  {
    name: 'linkedin',
    img: 'linkedin',
    link: 'https://www.linkedin.com/company/3709725/'
  },
  {
    name: 'facebook',
    img: 'facebook',
    link: 'https://www.facebook.com/TheUrbanDeveloper'
  },
  {
    name: 'instagram',
    img: 'instagram',
    link: 'https://www.instagram.com/theurbandeveloper/?hl=en/'
  },
  {
    name: 'youtube',
    img: 'youtube',
    link: 'https://www.youtube.com/channel/UCa56-rDddduXFM1KEE3Ldcg'
  }
];

export const BASE_URL = process.env.NEXT_PUBLIC_SITE_URL;
